import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  connect() {
    this.load();
  }

  load() {
    fetch(this.data.get("url"))
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.text();
      })
      .then(html => {
        this.element.innerHTML = html;
        if ($("#latest-charges-chart-container").length) {
          applyBrandStyles();
          latestInvoiceChargesChart();
          initializeTooltips();
        }
      })
      .catch(err => {
        showCardLoadError(this.element, err);
      });
  }
}
